const BASE_URL = "https://starfish-app-ettw4.ondigitalocean.app"
// const BASE_URL = "http://localhost:1337";

export {BASE_URL};